import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import env from '@lib/env'
const SENTRY_DSN = env().SENTRY_DSN

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
})

export default function () {
  const captureException = (error: unknown) => {
    if (__DEV__) {
      console.error(error)
      return
    }
    Sentry.captureException(error)
  }

  const captureMessage = (message: string) => {
    if (__DEV__) {
      console.info(message)
      return
    }
    Sentry.captureMessage(message)
  }

  return { captureException, captureMessage }
}
